// export interface PosProduct {
//   id: "t3pos" | "mpos" | "card-reader";
//   image: string;
//   name: string;
//   sale_price: number;
// }

export const posProducts = [
  {
    id: "t3pos",
    image: "/pos.jpg",
    name: "T3 POS",
    lease_price: 25000,
    sale_price: 150000,
  },
  {
    id: "mpos",
    image: "/mpos.jpg",
    name: "MPOS",
    lease_price: 15000,
    sale_price: 65000,
  },
  {
    id: "card-reader",
    image: "/card_reader.jpg",
    name: "Card Reader",
    lease_price: 10000,
    sale_price: 45000,
  },
];
